import script from "./UserPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPanel.vue?vue&type=script&setup=true&lang=js"

import "./UserPanel.vue?vue&type=style&index=0&id=cccde98c&lang=scss"

const __exports__ = script;

export default __exports__